export default function resolveAfter(ms, value) {
    return new Promise((resolve) => setTimeout(resolve, ms, value));
}
